import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
// import { push } from 'connected-react-router'

// amplify
import { Auth, API } from 'aws-amplify'
import { updateVolunteerMatchRequest } from './../../graphql/mutations'

// redux
import { getOpportunityActiveVolunteers, getOpportunityMatchRequests } from './opportunities'

interface MatchRequestState {
    selectedMatchRequest: any
}

const initialState: MatchRequestState = {
    selectedMatchRequest: null
}

export const acceptMatchRequest: any = createAsyncThunk(
    'matchRequest/acceptMatchRequest',
    async (props: any, { dispatch, getState }) => {
        try {

            const { matchRequest }: any = getState()

            const { data }: any = await API.graphql({
                query: updateVolunteerMatchRequest,
                variables: {
                    input: {
                        id: matchRequest.selectedMatchRequest.id,
                        status: 'positionAssigned'
                    }
                }
            })

            dispatch(getOpportunityActiveVolunteers())
            dispatch(getOpportunityMatchRequests())

        } catch (err) {
            console.error(err)
        }
    }
)

export const matchRequestSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        clearLocalData: (state) => {
            state.selectedMatchRequest = null
        },
        setSelectedMatchRequest: (state, action: PayloadAction<object>) => {
            state.selectedMatchRequest = action.payload
            console.log('setting selected match request', action.payload)
        }
    },
    extraReducers: (builder) => {
        builder.addCase(acceptMatchRequest.fulfilled, (state, { payload }) => {
            
        })
    }
})

export const { clearLocalData, setSelectedMatchRequest } = matchRequestSlice.actions
export default matchRequestSlice.reducer